var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from "react-hook-form";
import { useKushkiJsContext } from "../../../context/useKushkiJsContext";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import React, { useEffect, useState } from "react";
import { useValidate3DS } from "../../../hooks/useValidate3DS";
import { PaymentMethodsEnum } from "../../../shared/constants/PaymentMethodEnum";
import { isEmpty } from "lodash";
import { Translate as T } from "react-localize-redux";
export var useCardSubscriptionCheckoutState = function () {
    var form = useForm({
        shouldUnregister: false,
    });
    var _a = useKushkiJsContext(), requestCardSubscriptionToken = _a.requestCardSubscriptionToken, requestBin = _a.requestBin, requestBrandsLogos = _a.requestBrandsLogos;
    var validate3DSFlow = useValidate3DS().validate3DSFlow;
    var _b = useCheckoutContext(), handlers = _b.handlers, currency = _b.currency, kpayEnable = _b.kpayEnable, emailKpay = _b.emailKpay;
    var _c = useState(""), currentBin = _c[0], setCurrentBin = _c[1];
    var _d = useState(""), cardBrand = _d[0], setCardBrand = _d[1];
    var _e = useState(false), openTerms = _e[0], setOpenTerms = _e[1];
    var _f = useState([]), brands = _f[0], setBrands = _f[1];
    var getBin = function (newBin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardInfo_1, brand, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, requestBin({ bin: newBin })];
                case 1:
                    cardInfo_1 = _a.sent();
                    handlers.closeErrorNotification();
                    brand = brands.find(function (_a) {
                        var brand = _a.brand;
                        return brand.toLocaleLowerCase() === cardInfo_1.brand.toLocaleLowerCase();
                    });
                    setCardBrand((brand === null || brand === void 0 ? void 0 : brand.url) || cardInfo_1.brand);
                    handlers.setCardBrandContext(cardInfo_1.brand);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    handlers.showErrorNotification(e_1);
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getBrands = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cardTypeLogo, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handlers.setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, requestBrandsLogos()];
                case 2:
                    cardTypeLogo = _a.sent();
                    setBrands(cardTypeLogo);
                    handlers.setCheckoutLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getBrands();
    }, []);
    var setCheckoutToken = function (tokenResponse, formData) {
        var _a = formData.name.split(" "), firstName = _a[0], _b = _a[1], lastName = _b === void 0 ? "" : _b;
        handlers.setCheckoutToken({
            contactDetails: {
                email: formData.email,
                firstName: firstName,
                lastName: lastName,
            },
            paymentMethod: PaymentMethodsEnum.SUBSCRIPTION,
            secureId: tokenResponse.secureId,
            secureService: tokenResponse.secureService,
            token: tokenResponse.token,
        });
    };
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var expDate, cardNumber, tokenResponse_1, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    expDate = formData.expDate.split("/");
                    cardNumber = formData.cardNumber.replace(/ /g, "");
                    handlers.setTokenRequestLoading(true);
                    if (kpayEnable && formData.email)
                        handlers.setEmailKpay(formData.email);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, requestCardSubscriptionToken({
                            card: {
                                cvc: formData.cvc,
                                expiryMonth: expDate[0],
                                expiryYear: expDate[1],
                                name: formData.name,
                                number: cardNumber,
                            },
                            currency: currency,
                            // savePaymentData: kpayEnable,
                            emailRequest: isEmpty(emailKpay) ? formData.email : emailKpay,
                        })];
                case 2:
                    tokenResponse_1 = _a.sent();
                    handlers.closeErrorNotification();
                    return [4 /*yield*/, validate3DSFlow(tokenResponse_1, function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, setCheckoutToken(tokenResponse_1, formData)];
                        }); }); })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    e_3 = _a.sent();
                    handlers.showErrorNotification(e_3);
                    console.error(e_3);
                    return [3 /*break*/, 6];
                case 5:
                    handlers.setTokenRequestLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSetFields = function () {
        var cardNumber = String(form.getValues("cardNumber")).replace(/\s/g, "");
        var newBin = cardNumber.substring(0, 8);
        if (cardNumber.trim().length >= 8 && currentBin !== newBin) {
            setCurrentBin(newBin);
            getBin(newBin);
        }
        else if (cardNumber.trim().length < 8) {
            setCardBrand("");
        }
    };
    var isValidDate = function (expDate) {
        var monthDate = function (expDate) { return Number(expDate.split("/")[0]); };
        var yearDate = function (expDate) {
            return Number("20".concat(expDate.split("/")[1]));
        };
        return new Date() > new Date(yearDate(expDate), monthDate(expDate))
            ? (React.createElement(T, { id: "form.expirationDateIncorrect" }))
            : true;
    };
    return {
        brands: brands,
        cardBrand: cardBrand,
        emailKpay: emailKpay,
        form: form,
        handler: {
            handleKpayEnable: handlers.setKpayEnable,
            handleSetFields: handleSetFields,
            handleSubmit: handleSubmit,
        },
        isValidDate: isValidDate,
        kpayEnable: kpayEnable,
        openTerms: openTerms,
        setOpenTerms: setOpenTerms,
    };
};
